export const AUTO_SIGNATURE_CONSTANTS = {
  // Form control names
  SERVER_SIDE_SIGNATURE: 'server_side_siganture',

  // Message severity
  SEVERITY_ERROR: 'error',
  SEVERITY_WARN: 'warn',

  // Summaries
  AUTO_SIGNATURE_NOT_AVAILABLE: 'Auto Signature Not Available',
  AUTO_SIGNATURE_LIMIT: 'Auto Signature Limit',
  MANUAL_SIGNER_REQUIRED: 'Manual Signer Required',
  FILE_TOO_LARGE: 'File Too Large',
  INVALID_FILE: 'Invalid File',
  PROCESSING_ERROR: 'Processing Error',

  // Details
  AUTO_SIGNATURE_MIN_SIGNATORY:
    'Auto signature is available only with more than 1 signatory.',
  AUTO_SIGNATURE_MAX_LIMIT:
    'Maximum 10 signatories can be set as auto signature.',
  AUTO_SIGNATURE_MANUAL_REQUIRED:
    'At least one signatory must remain as manual signer.',
  PDF_TOO_MANY_IMAGES:
    'PDF contains too many images/tables. Try a different file.',
  NOT_VALID_PDF: 'Not a valid PDF file. Please upload another one',
  SINGLE_EXTENSION_REQUIRED: 'File name should have only single extension',
  PDF_PROCESSING_ERROR: 'Error processing PDF files. Please try again.',
};
